import React from "react";
import styles from "./Button.module.css";
import type { buttonProps } from "./types.props";

const Button: React.FC<buttonProps> = ({
    children,
    variant = "primary",
    isLoading = false,
    loadingText,
    fullWidth = false,
    leftIcon,
    rightIcon,
    className = "",
    ...props
}) => {
    const variantMap: { [key: string]: string } = {
        primary: styles["btn-primary"],
        secondary: styles["btn-secondary"],
        link: styles["btn-link"],
        icon: styles["btn-icon"],
    };

    const buttonBaseClasses = `
    ${styles["btn"]}
    ${variantMap[variant] || styles["btn-primary"]}
    ${fullWidth ? styles["btn-fullwidth"] : ""}
    ${isLoading ? styles["btn-loading"] : ""}
  `
        .trim()
        .replace(/\s+/g, " ");

    const finalButtonClasses = `${buttonBaseClasses} ${className}`.trim();

    return (
        <button
            type={props.type || "button"}
            className={finalButtonClasses}
            disabled={isLoading || props.disabled}
            {...props}
        >
            {isLoading && (
                <span className={styles["btn-spinner"]} aria-hidden="true" />
            )}
            {leftIcon && <span className={styles["btn-icon-left"]}>{leftIcon}</span>}
            {isLoading ? loadingText || children : children}
            {rightIcon && (
                <span className={styles["btn-icon-right"]}>{rightIcon}</span>
            )}
        </button>
    );
};

export default Button;
